import 'aos/dist/aos.css'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ShortcutNav from '../Shared/ShortcutNav'
import About from './About/About'
import Blogs from './Blogs/Blogs'
import Contact from './Contact/Contact'
import Hero from './Hero/Hero'
import MySkill from './MySkill/MySkill'
import AllProjects from './Project/AllProjects'
import JsProjects from './Project/JsProjects'
import Projects from './Project/Projects'
import ReactProjects from './Project/ReactProjects'
import ReduxProjects from './Project/ReduxProjects'
import Services from './Services/Services'

const Home = () => {
    return (
        <>
            <Hero />
            <Routes>
                <Route path="/" element={<Projects />}>
                    <Route index element={<AllProjects />} />
                    <Route path="react" element={<ReactProjects />} />
                    <Route path="redux" element={<ReduxProjects/>} />
                    <Route path="javascript" element={<JsProjects />} />
                </Route>
            </Routes>
            <Services />
            <About />
            <MySkill />
            <Blogs />
            <Contact />
            <ShortcutNav />
        </>
    )
}

export default Home
